<template>
  <div
    class="shipber-layout-box row space-between shipber-filter-tag"
    v-if="filterList.length"
  >
    <div class="left filter-tag-box__tag">
      <el-tag
        v-for="tag in filterList"
        :key="tag.key"
        class="ellipsis"
        :class="{ 'no-closable': !tag.closable }"
        :closable="tag.closable"
        :type="tag.type"
        @close="handleCloseTag(tag.key, tag.type)"
      >
        <span class="tag-wrapper">
          <span class="title">{{ tag.label + ': ' }}</span>
          <span class="label"> {{ tag.value }}</span>
        </span>
      </el-tag>
    </div>
    <div class="right filter-tag-box__tool">
      <el-button
        v-if="isSave"
        type="text"
        size="medium"
        class="filters-clear"
        @click="handleSaveFilter"
      >
        <el-tooltip
          class="item"
          effect="dark"
          :content="$tc('adb-filter.saveFilter')"
          placement="top-start"
        >
          <adb-icon icon-class="spb-save" />
        </el-tooltip>
      </el-button>
      <span v-if="isSave">|</span>
      <!-- 清除的 -->
      <el-button type="text" class="filters-clear" @click="handleClearFilter">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$tc('adb-filter.clearAll')"
          placement="top-start"
        >
          <adb-icon icon-class="spb-clear" />
        </el-tooltip>
      </el-button>
    </div>
  </div>
</template>

<script>
import { resetDate, resetItem } from '@adber/shipber-ui/utils/filters';
import AdbIcon from '@adber/shipber-ui/packages/base/adb-icon';
import commonMessage from '@adber/shipber-ui/packages/locale';

export default {
  name: 'adb-filter-tag',
  i18n: {
    sharedMessages: commonMessage,
  },
  components: { AdbIcon },
  props: {
    // 必传的获取过滤类型
    type: {
      type: String,
      default: '',
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    // 传递过来的过滤信息
    filterOptions: {
      type: Array,
      default: () => ({}),
      required: true,
    },
    // 自己调接口还是父组件调接口
    isCallInterfaceSelf: {
      type: Boolean,
      default: true,
      required: false,
    },
    isSave: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    // 如果可以自己调接口
    if (this.isCallInterfaceSelf) {
      // 获取过滤信息
      this.getFilterOption();
    }
  },
  data() {
    return {
      filters: this.$_.cloneDeep(this.value),
    };
  },
  watch: {
    value: {
      handler(newVal) {
        if (this.$_.isEqual(newVal, this.filter)) return;
        this.filters = this.$_.cloneDeep(this.value);
      },
      deep: true,
    },
  },
  computed: {
    filterList() {
      const arr = [];
      Object.keys(this.filters).forEach((key) => {
        const option = this.filterOptions.find((opt) => opt.key === key);
        if (!option) return;
        const value = this.filters[key];
        const init = resetItem(option.type);
        let value_str = value;
        let cuOption = {};
        switch (option.type) {
          case 'radio':
            cuOption = option.options.find((d) => d.value === value);
            if (cuOption) {
              value_str = cuOption.label;
            }
            break;
          case 'checkbox':
            value_str = value
              .map((value) => {
                cuOption = option.options.find((d) => d.value === value);
                return cuOption ? cuOption.label : false;
              })
              .filter((d) => d)
              .join(',');
            break;
          case 'amount-range':
            value_str = `$ ${value.join(' ~ ')}`;
            break;
          case 'date-picker':
            value_str = value
              .map((date) => this.$adbDayjs.getDate(date))
              .join('-');
            break;
          case 'number-range':
            value_str = `${value.join(' ~ ')}`;
            break;
          case 'select':
            cuOption = option.options.find((d) => d.value === value);
            if (cuOption) {
              value_str = cuOption.label;
            }
            break;
          default:
            value_str = value;
            break;
        }
        if (!this.$_.isEqual(value, init)) {
          const obj = {
            label: option.label,
            key: key,
            value: option.formatValue
              ? option.formatValue(this.filters[key])
              : value_str,
            type: option.type,
            closable: !option.is_hide,
          };
          arr.push(obj);
        }
      });
      return arr;
    },
  },
  methods: {
    handleCloseTag(key, type) {
      const filters = this.$_.cloneDeep(this.filters);
      filters[key] = resetItem(type);
      this.$emit('input', filters);
      this.$emit('commit');
    },

    // 获取过滤信息
    getFilterOption() {
      const params = {
        type: this.type,
      };
      console.log(params);
      // this.axios
      //   .get(this.$APIPath.TableColumnFilter.getTableColumnFilter, { params })
      //   .then((res) => {
      //     // 过滤条件为空
      //     if (JSON.stringify(res.data) === '{}') {
      //       // this.filterList = [];
      //       // this.$emit('getTableData', {});
      //     } else {
      //       // this.filterList =
      //       //   res.data.filter_json && res.data.filter_json.filter_label
      //       //     ? JSON.parse(JSON.stringify(res.data.filter_json.filter_label))
      //       //     : [];
      //       // this.$emit('getTableData', res.data.filter_json);
      //     }
      //   })
      //   .catch(() => {})
      //   .finally(() => {});
    },

    handleClearFilter() {
      const options = this.filterOptions.filter((item) => !item.is_hide);
      this.$emit('input', resetDate(options, this.filters));
      this.$emit('commit');
    },

    // 保存过滤信息前的校验
    handleSaveFilter() {
      this.saveFilterOption();
    },
    // 保存过滤的信息
    saveFilterOption() {
      this.$emit('input', this.filters);
      this.$emit('save');

      // this.axios
      //   .post(this.$APIPath.TableColumnFilter.saveTableColumnFilter, params)
      //   .then((res) => {
      //     if (res && res.data) {
      //       this.$message.success('Successfully Saved');
      //     }
      //   });
    },
  },
};
</script>

<style lang="scss" scoped>
.shipber-filter-tag {
  margin-bottom: 16px;
  /deep/ .el-tag {
    height: 24px;
    border-radius: 4px;
    border: none;
    position: relative;
    padding-right: 24px;
    background-color: #eff2f6;
    margin-bottom: 4px;
    margin-right: 5px;
    max-width: 320px;

    .el-tag__close {
      color: #7c8794;
    }

    .el-tag__close:hover {
      background: #4097fd;
      color: #ffffff;
    }

    .el-icon-close {
      position: absolute;
      top: 4px;
      right: 6px;
    }
    &.no-closable {
      padding-right: 8px;
    }
    .tag-wrapper {
      cursor: pointer;
      line-height: 24px;
      font-size: 14px;
      font-weight: 400;
      color: #5c6570;
      .title {
        font-weight: 500;
      }
    }
  }

  .filter-tag-box {
    &__tag {
      flex: 1;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-bottom: -4px;
    }

    &__tool {
      color: #32363b;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      & > * {
        margin-right: 0 !important;
      }

      span {
        padding: 0 30px;
        color: #eaedf0;
        font-size: 14px;
      }

      /deep/ .el-button {
        width: 36px;
        height: 24px;
        font-size: 14px;
        color: #5c6570;
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;

        &:hover {
          color: #4097fd;
          background: #f0f7ff;
        }
      }

      /deep/ .el-button.is-disabled.el-button--text:hover {
        background: none;
        opacity: 0.3;
      }
    }
  }
  .ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
